import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { PageHeader } from "@/components/app/Layout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { toast } from "sonner";
import { PlanForm } from "@/components/langganan/PlanForm";
import { PlansTab, WorkspacesTab, PaymentsTab, BillingTab } from "@/components/langganan/SaTabs";

export default function SuperAdminLangganan() {
  const [plans, setPlans] = useState([]);
  const [features, setFeatures] = useState([]);
  const [editing, setEditing] = useState(null);
  const [pending, setPending] = useState(0);
  const load = () => {
    api.get("/sa/paket").then((r) => setPlans(r.data)).catch((e) => toast.error(formatApiError(e)));
    api.get("/sa/langganan/pembayaran/count").then((r) => setPending(r.data.pending)).catch(() => {});
  };
  useEffect(() => { load(); api.get("/langganan/fitur").then((r) => setFeatures(r.data)).catch(() => {}); }, []);

  if (editing) {
    return (
      <div className="p-4 md:p-8">
        <PlanForm plan={editing === "new" ? null : editing} features={features} onBack={() => setEditing(null)} onSaved={() => { setEditing(null); load(); }}/>
      </div>
    );
  }
  return (
    <div>
      <PageHeader title="Paket Langganan" subtitle="Buat paket, atur langganan workspace, dan konfirmasi pembayaran transfer."/>
      <div className="p-4 md:p-8">
        <Tabs defaultValue="paket">
          <TabsList className="mb-5 flex-wrap h-auto">
            <TabsTrigger value="paket" data-testid="tab-paket">Paket</TabsTrigger>
            <TabsTrigger value="workspace" data-testid="tab-workspace">Langganan Workspace</TabsTrigger>
            <TabsTrigger value="pembayaran" data-testid="tab-pembayaran">Pembayaran{pending > 0 && <span className="ml-1.5 min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] inline-flex items-center justify-center" data-testid="tab-pembayaran-badge">{pending}</span>}</TabsTrigger>
            <TabsTrigger value="pengaturan" data-testid="tab-pengaturan">Pengaturan</TabsTrigger>
          </TabsList>
          <TabsContent value="paket"><PlansTab plans={plans} onNew={() => setEditing("new")} onEdit={setEditing} reload={load}/></TabsContent>
          <TabsContent value="workspace"><WorkspacesTab plans={plans}/></TabsContent>
          <TabsContent value="pembayaran"><PaymentsTab onChange={load}/></TabsContent>
          <TabsContent value="pengaturan"><BillingTab/></TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
